import is from 'is_js';

export const isMobileOrTablet = () => is.mobile() || is.tablet();
